function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Select, IndexPath, SelectItem } from "../../../native";
import * as R from 'unitx/ramda';
import { asNumber, guessType // setUninitializedValue,
} from "../../utils";
import { useFormContext } from "../FormContext";
const nums = new Set(['number', 'integer']);
/**
 * This is a silly limitation in the DOM where option change event values are
 * always retrieved as strings.
 */

const processValue = (schema, value) => {
  // "enum" is a reserved word, so only "type" and "items" can be destructured
  const {
    type,
    items
  } = schema;
  return R.cond([[() => R.isEmptyString(value), () => undefined], [() => type === 'array' && items && nums.has(items.type), () => value.map(asNumber)], [R.equals('boolean'), () => value === 'true'], [R.equals('number'), () => asNumber(value)], [() => schema.enum && schema.enum.every(x => guessType(x) === 'number'), () => asNumber(value)], [() => schema.enum && schema.enum.every(x => guessType(x) === 'boolean'), () => value === 'true'], [R.T, R.always(value)]])(type);
};

const SelectWidget = ({
  schema,
  id,
  options,
  disabled,
  readonly,
  value,
  multiple,
  // autofocus,
  onChange,
  onBlur,
  onFocus,
  formContext,
  required
}) => {
  const {
    enumOptions
  } = options; // const emptyValue = multiple ? [] : ''

  const {
    mapping
  } = useFormContext(formContext);
  const optionsData = enumOptions.map(({
    value: enumValue,
    label
  }) => ({
    title: label,
    value: enumValue
  }));
  const dataRef = React.useRef({
    selectedOptionIndex: new IndexPath(0)
  });
  React.useMemo(() => {
    const itemIndex = R.findIndex(R.propEq('value', value))(optionsData);

    if (itemIndex > -1) {
      dataRef.current.selectedOptionIndex = new IndexPath(itemIndex);
    }
  }, []); // @TODO:TEST
  // React.useMemo(() => {
  //   const itemIndex = R.findIndex(R.propEq('value', value))(optionsData)
  //   const uninitialized = R.isNegative(itemIndex)
  //   dataRef.current.selectedOptionIndex = new IndexPath(
  //     uninitialized ? 0 : itemIndex,
  //   )
  //   setUninitializedValue({
  //     getDefault: () => processValue(schema, optionsData[dataRef.current.selectedOptionIndex.row]?.value),
  //     condition: uninitialized,
  //     onChange,
  //     required,
  //   })
  // }, [])
  // @TODO:TEST_END

  return /*#__PURE__*/React.createElement(Select, _extends({}, mapping.select, {
    style: [mapping.select.style],
    multiSelect: typeof multiple === 'undefined' ? false : multiple,
    selectedIndex: dataRef.current.selectedOptionIndex // required={required}
    ,
    disabled: disabled || readonly || R.lengthEq(1)(optionsData) // autoFocus={autofocus}
    ,
    value: optionsData[dataRef.current.selectedOptionIndex.row].title // @ts-ignore
    ,
    onSelect: selectedIndex => {
      dataRef.current.selectedOptionIndex = selectedIndex; // setState({ selectedOptionIndex: selectedIndex })

      onChange(processValue(schema, optionsData[selectedIndex.row].value));
    },
    onBlur: () => onBlur(id, processValue(schema, value)),
    onFocus: () => onFocus(id, processValue(schema, value))
  }), R.map(item => /*#__PURE__*/React.createElement(SelectItem, {
    key: item.title,
    title: item.title
  }))(optionsData));
};

export default SelectWidget;